import React from 'react'
import style from './TextContent.module.css'

const TextContent = () => {
    return (
        <div className={style.TextContent}>
            <h1 className={style.mainHeading}>SUPPORT THE INITIATIVES OF ISKCON VIJAYAWADA</h1>

            <p className={style.patagContent}>
               Be a Part of ISKCON Vijayawada's noble initiatives food for all , Value based education and selfless services every donation you make empowers change and transforms the community.
            </p>
        </div>
    )
}

export default TextContent
